"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBButton;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _plusWhite_button = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/plus-white_button.svg"));
var _plusGray_button = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/plus-gray_button.svg"));
var _plusBlue_button = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/plus-blue_button.svg"));
var _chevronDownWhite_button = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-down-white_button.svg"));
var _chevronDownGray_button = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-down-gray_button.svg"));
var _chevronDownBlue_button = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-down-blue_button.svg"));
var _chevronRightDisabled = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-right-disabled.svg"));
var _chevronRightArrow = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-right-arrow.svg"));
var _chevronRightArrowDisabled = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-right-arrow-disabled.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Global components
 * By Juan Rodrigo <jponceflores@svb.com> (www.svb.com)
 * Summary
 * This component renders a SVB button
 */

/**
 * SVBButton
 * @param {string} [text = "Button"] - Text displayed in the button
 * @param {string} [size = "large"] - Size of the button
 * @param {string} [style = "primary"] - Style of the button
 * @param {string} [state = "default"] - State of the button
 * @param {string} [type = "icon"] - Type of the button
 * @param {(string|string[])} [icon = "check"] - Name of the icon
 * @param {string} [iconSide = ""] - Side where the icon is positioned within the button
 * @param {string} [extraClasses = ""] - Extra classes to be added to the button element
 * @param {string} [leftIconExtraClasses = "pe-1"] - Extra classes to be added to the left img element
 * @param {string} [rightIconExtraClasses = ""] - Extra classes to be added to the right img element
 * @param {function} onClick - Function to execute when the button is clicked
 * @returns JSX element
 */

function SVBButton(props) {
  let componentError = false;
  const dataTestid = props.dataTestid || "";
  const typeCheck = function typeCheck(prop, types) {
    let extraValidations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!types.includes(typeof prop)) componentError = true;
    if (extraValidations && typeof prop !== "undefined") {
      for (let validation of extraValidations) {
        if (!validation(prop)) componentError = true;
      }
    }
    return prop;
  };
  const isArrayOfStrings = value => {
    if (Array.isArray(value)) return value.every(i => typeof i === "string");else return true;
  };
  const text = typeCheck(props.text, ["string", "undefined"]) || "Button";
  const size = typeCheck(props.size, ["string", "undefined"], [value => ["large", "small"].includes(value)]) || "large";
  const style = typeCheck(props.style, ["string", "undefined"], [value => ["primary", "secondary", "text"].includes(value)]) || "primary";
  const state = typeCheck(props.state, ["string", "undefined"], [value => ["disabled", "default"].includes(value)]) || "default";
  const type = typeCheck(props.type, ["string", "undefined"], [value => ["icon", "text"].includes(value)]) || "icon";
  const iconSide = typeCheck(props.iconSide, ["string", "undefined"], [value => ["left", "right"].includes(value)]) || "";
  const iconString = typeCheck(props.icon, ["string", "object", "undefined"], [isArrayOfStrings]) || "";
  const icon = getIcon(iconString);
  const onClick = typeCheck(props.onClick, ["function"]);
  const extraClasses = typeCheck(props.extraClasses, ["string", "undefined"]) || "";
  const leftIconExtraClasses = typeCheck(props.leftIconExtraClasses, ["string", "undefined"]) || "pe-1";
  const rightIconExtraClasses = typeCheck(props.rightIconExtraClasses, ["string", "undefined"]) || "";
  if (componentError) return /*#__PURE__*/_react.default.createElement("p", null, "Invalid prop sent, check console for prop type errors.");
  const displayText = (type, icon, iconSide, text) => {
    if (Array.isArray(icon)) return [/*#__PURE__*/_react.default.createElement("span", {
      className: "icon-container"
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: leftIconExtraClasses,
      key: "icon-left",
      src: icon[0]
    })), text, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-container"
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: rightIconExtraClasses,
      key: "icon-right",
      src: icon[1]
    }))];else if (type === "icon") return /*#__PURE__*/_react.default.createElement("img", {
      key: "icon-center",
      src: icon
    });else switch (iconSide) {
      case "left":
        return [/*#__PURE__*/_react.default.createElement("span", {
          className: "icon-container"
        }, /*#__PURE__*/_react.default.createElement("img", {
          className: leftIconExtraClasses,
          key: "icon-left",
          src: icon
        })), text];
      case "right":
        return [text, /*#__PURE__*/_react.default.createElement("span", {
          className: "icon-container"
        }, /*#__PURE__*/_react.default.createElement("img", {
          className: rightIconExtraClasses,
          key: "icon-right",
          src: icon
        }))];
      default:
        return text;
    }
  };
  function getIcon(icon) {
    //allowedIcons: "down" || "check"
    if (icon === "down") {
      if (state === "disabled") return _chevronDownGray_button.default;
      if (style === "primary") return _chevronDownWhite_button.default;else return _chevronDownBlue_button.default; //Secondary and Text
    } else if (icon === "right-disabled") {
      return _chevronRightDisabled.default; //Secondary and Text
    } else if (icon === "right-arrow") {
      if (state === "disabled") {
        return _chevronRightArrowDisabled.default;
      } else {
        return _chevronRightArrow.default;
      }
    } else if (icon === "check" || !icon) {
      if (state === "disabled") return _plusGray_button.default;
      if (style === "primary") return _plusWhite_button.default;else return _plusBlue_button.default; //Secondary and Text
    } else if (Array.isArray(icon)) return icon.map(item => {
      try {
        return require("@svb/svbbranding/dist/assets/icons/" + item);
      } catch (error) {
        return;
      }
    });else try {
      return require("@svb/svbbranding/dist/assets/icons/" + icon);
    } catch (error) {
      return;
    }
  }
  return /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: onClick,
    "data-testid": dataTestid ? dataTestid : null,
    className: "svb-button svb-button_".concat(size, " svb-button_").concat(style, "-").concat(state, " svb-button_type-").concat(type, " ").concat(extraClasses)
  }, displayText(type, icon, iconSide, text));
}
SVBButton.propTypes = {
  text: _propTypes.default.string,
  size: _propTypes.default.oneOf(["large", "small"]),
  style: _propTypes.default.oneOf(["primary", "secondary", "text"]),
  state: _propTypes.default.oneOf(["disabled", "default"]),
  type: _propTypes.default.oneOf(["icon", "text"]),
  iconSide: _propTypes.default.oneOf(["left", "right"]),
  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  onClick: _propTypes.default.func.isRequired,
  extraClasses: _propTypes.default.string,
  leftIconExtraClasses: _propTypes.default.string,
  rightIconExtraClasses: _propTypes.default.string
};